var zero = function zero(num){
        var len = 2, str = ''+ num;
        while( str.length < len){
            str = '0'+ str;
        }
        return str;
    };
module.exports = function (nbr, options){
     var hrs = Math.floor(nbr / 3600);
    var min = Math.floor((nbr - (hrs * 3600)) / 60);
    var sec = Math.floor(nbr % 60);
    var str = (hrs ? zero(hrs) + ':' : '00:') + zero(min) + ':' + zero(sec);
    return str;
};



//////////////////
// WEBPACK FOOTER
// ./src/webpack/helpers/digits.js
// module id = 24
// module chunks = 0 1